import { EntityIcon } from '..';
import { TProps } from '../types/TProps';

const mdSizeClassName = 'h-12 w-12 bg-[var(--color-avatar-bg)] text-lg leading-[130%] text-[var(--color-on-surface)]';

export const EntityIconMd = ({ className, sizeClassName, ...props }: TProps) => (
  <EntityIcon {...props} sizeClassName={sizeClassName ?? mdSizeClassName} className={className} />
);
